const form = document.querySelector('.contacts__form form');

form.addEventListener('submit', () => {
    const submit = form.querySelector('.wpcf7-submit');
    submit.disabled = true;
});

document.addEventListener('wpcf7submit', (event) => { 
    const submit = event.target.querySelector('.wpcf7-submit');

    if (submit) {
        submit.disabled = false;
    }
});